module.exports = __webpack_public_path__ + "img/cloudy.0ad07230.svg";